enum WsMemberErrorStatus {
  Onboarding = "onboarding",
  NoActiveSubscription = "no-active-subscription",
}

export { WsMemberErrorStatus };
